import { AppConfig } from '@/Ship/Configs/AppConfig'
import { formatAppDate } from '@/Ship/Helpers/appTime'

export interface AuditUser {
    shortName?: string | null
    fullName?: string | null
}

export interface AuditRow {
    key: 'id' | 'uuid' | 'createdAt' | 'updatedAt'
    label: string
    value: string
    /** Автор для «Створено»/«Змінено»: undefined — поля немає у відповіді, null — порожнє */
    author?: string | null | undefined
    copyable?: boolean
}

/** Дата у форматі таблиць (`AppConfig.datetimeDefaultFormat`) у часі порталу; невалідна або порожня → null */
export const formatAuditDate = (value: unknown): string | null =>
    formatAppDate(value, AppConfig.datetimeDefaultFormat ?? 'YYYY-MM-DD HH:mm')

/** Ім'я автора: shortName → fullName → null */
export const formatAuditUser = (user: unknown): string | null => {
    if (!user || typeof user !== 'object') return null
    const { shortName, fullName } = user as AuditUser
    return shortName?.trim() || fullName?.trim() || null
}

/** Рядки блоку «Службова інформація» з даних картки — лише ті, для яких є дані */
export const buildAuditRows = (values: Record<string, unknown> | null | undefined): AuditRow[] => {
    if (!values) return []
    const rows: AuditRow[] = []

    const id = values['id']
    if (id !== undefined && id !== null && id !== '') {
        rows.push({ key: 'id', label: 'ID', value: String(id), copyable: true })
    }

    const uuid = values['uuid']
    if (typeof uuid === 'string' && uuid !== '') {
        rows.push({ key: 'uuid', label: 'UUID', value: uuid, copyable: true })
    }

    const created = formatAuditDate(values['createdAt'])
    if (created) {
        rows.push({
            key: 'createdAt',
            label: 'Створено',
            value: created,
            author: 'createdBy' in values ? formatAuditUser(values['createdBy']) : undefined,
        })
    }

    const updated = formatAuditDate(values['updatedAt'])
    if (updated) {
        rows.push({
            key: 'updatedAt',
            label: 'Змінено',
            value: updated,
            author: 'updatedBy' in values ? formatAuditUser(values['updatedBy']) : undefined,
        })
    }

    return rows
}
